import PropTypes from 'prop-types';
import { Grid, FormControl, InputLabel, Select, MenuItem, Chip, FormHelperText, Box, CircularProgress, Typography } from '@mui/material';
import { WorkOutlined } from '@mui/icons-material';
import SectionHeader from '../SectionHeader';
import SearchableSelect from '../SearchableSelect';
import { ROLES } from '../../utils/addEmployeeConstants';

const RoleAndLeadSection = ({
    form,
    handleChange,
    handleBlur,
    errors,
    touched,
    showL1,
    isL1Loading,
    l1Options,
    expectedL1RoleLabel,
    isEditMode
}) => {
    return (
        <>
            <SectionHeader icon={WorkOutlined} title="Role & Reporting" subtitle="Assign role and L1 reporting lead" />
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required error={touched.role && !!errors.role}>
                        <InputLabel>Role</InputLabel>
                        <Select
                            value={form.role}
                            label="Role"
                            onChange={handleChange('role')}
                            onBlur={handleBlur('role')}
                            readOnly={isEditMode}
                            startAdornment={
                                <Box sx={{ mr: 1, display: 'flex' }}>
                                    <WorkOutlined fontSize="small" color={touched.role && errors.role ? 'error' : 'action'} />
                                </Box>
                            }
                            sx={{ borderRadius: 2 }}
                        >
                            {ROLES.map((r) => (
                                <MenuItem key={r.id} value={r.id}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Chip
                                            label={`L${r.level}`}
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            sx={{ fontSize: '0.65rem', height: 20 }}
                                        />
                                        {r.label}
                                    </Box>
                                </MenuItem>
                            ))}
                        </Select>
                        {touched.role && errors.role && <FormHelperText>{errors.role}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* L1 Lead — only shown if role has a parent */}
                {showL1 && (
                    <Grid item xs={12} sm={6}>
                        {isL1Loading ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '56px',
                                    px: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 2
                                }}
                            >
                                <CircularProgress size={20} sx={{ mr: 2 }} />
                                <Typography variant="body2" color="text.secondary">
                                    Loading Managers...
                                </Typography>
                            </Box>
                        ) : (
                            <SearchableSelect
                                label={expectedL1RoleLabel}
                                required
                                value={form.l1Lead}
                                onChange={handleChange('l1Lead')}
                                onBlur={handleBlur('l1Lead')}
                                options={l1Options}
                                error={touched.l1Lead && !!errors.l1Lead}
                                helperText={touched.l1Lead && errors.l1Lead}
                                icon={WorkOutlined}
                                disabled={l1Options.length === 0}
                            />
                        )}
                    </Grid>
                )}
            </Grid>
        </>
    );
};

RoleAndLeadSection.propTypes = {
    form: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    showL1: PropTypes.bool.isRequired,
    isL1Loading: PropTypes.bool.isRequired,
    l1Options: PropTypes.array.isRequired,
    expectedL1RoleLabel: PropTypes.string.isRequired,
    isEditMode: PropTypes.bool
};

export default RoleAndLeadSection;
